import type { GridPosition } from '../rendering/types';

export interface ReelLayout {
  readonly stageWidth: number;
  readonly stageHeight: number;
  readonly startX: number;
  readonly startY: number;
  readonly reelWidth: number;
  readonly symbolHeight: number;
  readonly columnGap: number;
  readonly rowGap: number;
  readonly reelCount: 5;
  readonly rowCount: 3;
}

export const TEMPLE_SLOT_LAYOUT: ReelLayout = Object.freeze({
  stageWidth: 1_000,
  stageHeight: 600,
  startX: 68,
  startY: 54,
  reelWidth: 160,
  symbolHeight: 156,
  columnGap: 16,
  rowGap: 12,
  reelCount: 5,
  rowCount: 3,
});

export interface Rect {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export function getReelHeight(layout: ReelLayout = TEMPLE_SLOT_LAYOUT): number {
  return layout.rowCount * layout.symbolHeight + (layout.rowCount - 1) * layout.rowGap;
}

export function getCellRect(
  position: GridPosition,
  layout: ReelLayout = TEMPLE_SLOT_LAYOUT,
): Rect {
  return {
    x: layout.startX + position.reel * (layout.reelWidth + layout.columnGap),
    y: layout.startY + position.row * (layout.symbolHeight + layout.rowGap),
    width: layout.reelWidth,
    height: layout.symbolHeight,
  };
}

export function getCellCenter(
  position: GridPosition,
  layout: ReelLayout = TEMPLE_SLOT_LAYOUT,
): { readonly x: number; readonly y: number } {
  const rect = getCellRect(position, layout);
  return { x: rect.x + rect.width / 2, y: rect.y + rect.height / 2 };
}

export function getBoardBounds(layout: ReelLayout = TEMPLE_SLOT_LAYOUT): Rect {
  return {
    x: layout.startX,
    y: layout.startY,
    width: layout.reelCount * layout.reelWidth + (layout.reelCount - 1) * layout.columnGap,
    height: getReelHeight(layout),
  };
}

export function fitContain(
  sourceWidth: number,
  sourceHeight: number,
  targetWidth: number,
  targetHeight: number,
): { readonly width: number; readonly height: number } {
  if (sourceWidth <= 0 || sourceHeight <= 0 || targetWidth <= 0 || targetHeight <= 0) {
    return { width: 0, height: 0 };
  }
  const scale = Math.min(targetWidth / sourceWidth, targetHeight / sourceHeight);
  return { width: sourceWidth * scale, height: sourceHeight * scale };
}
